export var formatUserName = function (firstName, lastName) {
    return "".concat(firstName).concat(lastName ? " ".concat(lastName) : '').trim();
};
